import React, { createContext, useContext } from 'react';
import { UserProfile } from '../types';
import { useAuthWorkspace } from './AuthWorkspaceContext';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { clearSessionActivity } from '../utils/sessionInactivity';

interface AuthContextType {
  user: UserProfile | null;
  isSuperadmin: boolean;
  role: 'admin' | 'user' | string;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { currentUser, setCurrentUser } = useAuthWorkspace();

  const isSuperadmin = Boolean(
    currentUser?.superadmin ||
    ['rtrudslev@gmail.com', 'ricco@signer.dk', 'billing-cron@idura.dk'].includes(
      (currentUser?.email || '').toLowerCase().trim()
    )
  );

  const role = currentUser?.role || 'user';

  const logout = async () => {
    try {
      clearSessionActivity();
      await signOut(auth);
      setCurrentUser(null);
    } catch (err) {
      console.error("Fejl ved logud:", err);
    }
  };

  return (
    <AuthContext.Provider value={{ user: currentUser, isSuperadmin, role, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
